import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import './ChatConfirmation.scss';

/**
 * Componente de confirmación después de enviar el formulario
 * Muestra un mensaje de éxito y un timer de 10 segundos
 */
const ChatConfirmation = ({ timer, onTimeout, onBackToMenu }) => {
  useEffect(() => {
    if (timer === 0) {
      onTimeout();
    }
  }, [timer, onTimeout]);

  return (
    <div className="chat-confirmation">
      <div className="chat-confirmation__icon">
        <span className="material-symbols-rounded">check_circle</span>
      </div>

      <h3 className="chat-confirmation__title">
        {I18n.t('chatbot.contact.success')}
      </h3>

      <p className="chat-confirmation__message">
        {I18n.t('chatbot.contact.successMessage')}
      </p>

      {timer !== null && timer > 0 && (
        <p className="chat-confirmation__timer">
          {I18n.t('chatbot.contact.returning').replace('{{seconds}}', timer)}
        </p>
      )}

      <button className="chat-confirmation__btn" onClick={onBackToMenu}>
        <span className="material-symbols-rounded">home</span>
        {I18n.t('chatbot.navigation.backToMenu')}
      </button>
    </div>
  );
};

ChatConfirmation.propTypes = {
  timer: PropTypes.number,
  onTimeout: PropTypes.func.isRequired,
  onBackToMenu: PropTypes.func.isRequired,
};

export default ChatConfirmation;
